import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UtilityMenu } from 'components/UtilityMenu';
import { getMachine } from 'lib/selectors/getMachine';
import { CategorizeDowntime } from './CategorizeDowntime';
import { ControlBarResponsive, SingleButtonScrollable } from '../styled';

/**
 * Control bar component for signed-out state in ERP-driven mode.
 *
 * This component is rendered when:
 * - No operator is signed in
 * - System is in ERP-driven mode
 * - No job is currently running
 *
 * In this state, the user can only categorize downtime.
 * Operator sign-in is not available in ERP-driven mode as jobs
 * are dispatched automatically by the ERP system.
 *
 * @returns {JSX.Element} Control bar with only downtime categorization option
 */
const SignedOutErpDriven = () => {
  const history = useHistory();
  const machine = useSelector(getMachine);

  return (
    <ControlBarResponsive id="job-control-bar">
      <UtilityMenu />
      <SingleButtonScrollable>
        <CategorizeDowntime history={history} machine={machine} />
      </SingleButtonScrollable>
    </ControlBarResponsive>
  );
};

export { SignedOutErpDriven };
